// 需要固定高度的组件
const FixedHeightComps = [
    'pipeline-brand',
    'pipeline-cashBack',
    'pipeline-cashBackAct',
    'pipeline-community',
    'pipeline-communityArticle',
    'pipeline-goodsHorizontal',
    'pipeline-hotspots',
    'pipeline-image',
    'pipeline-imgHotMap',
    'pipeline-imgList',
    'pipeline-imgAnimate',
    'pipeline-product',
    'pipeline-productLayout3',
    'pipeline-imgListScroll',
    'pipeline-imgs',
    'pipeline-imgSwiper',
    'pipeline-navigation',
    'pipeline-pkRank',
    'pipeline-productSwiper',
    'pipeline-rank',
    'pipeline-rankList',
    'pipeline-springFestivalFloor',
    'pipeline-square',
    'pipeline-subsidy',
    'pipeline-subsidyList',
    'pipeline-vote',
]

export default FixedHeightComps;


// WEBPACK FOOTER //
// ./utils/fixedHeightComps.js